import React, { useCallback, useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
const names = ['Sarah', 'María', 'Carlos', 'Ana', 'Diego', 'Laura', 'Javier', 'Sofía', 'Miguel', 'Valentina', 'Andrés', 'Camila', 'Pablo', 'Isabella', 'Lucas', 'Daniela', 'Alejandro', 'Gabriela', 'Martín', 'Elena'];
const cities = ['Madrid', 'Barcelona', 'México DF', 'Buenos Aires', 'Lima', 'Bogotá', 'Santiago', 'Miami', 'Sevilla', 'Medellín', 'Montevideo', 'Quito', 'Valencia', 'Guadalajara', 'Córdoba', 'San José', 'Panamá', 'Bilbao'];
const productName = 'Neuro Reset Somático';
export function SalesNotification() {
  const [visible, setVisible] = useState(false);
  const [currentName, setCurrentName] = useState('');
  const [currentCity, setCurrentCity] = useState('');
  const [isMobile, setIsMobile] = useState(false);
  const pickRandom = useCallback(() => {
    setCurrentName(names[Math.floor(Math.random() * names.length)]);
    setCurrentCity(cities[Math.floor(Math.random() * cities.length)]);
  }, []);
  useEffect(() => {
    const checkMobile = () => setIsMobile(window.innerWidth <= 768);
    checkMobile();
    window.addEventListener('resize', checkMobile);
    return () => window.removeEventListener('resize', checkMobile);
  }, []);
  useEffect(() => {
    if (!isMobile) return;
    pickRandom();
    setVisible(true);
    const interval = setInterval(() => {
      setVisible(false);
      setTimeout(() => {
        pickRandom();
        setVisible(true);
      }, 3000);
    }, 6000);
    return () => clearInterval(interval);
  }, [isMobile, pickRandom]);
  if (!isMobile) return null;
  return <div className="fixed bottom-6 left-4 right-4 z-50 pointer-events-none" data-id="element-242">
      <AnimatePresence data-id="element-243">
        {visible && <motion.div initial={{
        opacity: 0,
        y: 30,
        scale: 0.95
      }} animate={{
        opacity: 1,
        y: 0,
        scale: 1
      }} exit={{
        opacity: 0,
        y: 10,
        scale: 0.98
      }} transition={{
        type: 'spring',
        stiffness: 400,
        damping: 25,
        mass: 0.8
      }} className="pointer-events-auto mx-auto max-w-sm" data-id="element-244">
            <div className="flex items-center gap-3 rounded-2xl px-4 py-3 shadow-xl border border-white/10" style={{
          background: 'rgba(30, 30, 40, 0.85)',
          backdropFilter: 'blur(20px)',
          WebkitBackdropFilter: 'blur(20px)'
        }} data-id="element-245">
              <img src="https://cdn.magicpatterns.com/uploads/qThLRYxDvrmmpUiuCbHsaz/Imagen_Hero.png" alt={productName} className="w-12 h-12 rounded-xl object-cover flex-shrink-0" data-id="element-246" />
              <div className="flex-1 min-w-0" data-id="element-247">
                <p className="text-white/90 text-sm font-medium leading-tight" data-id="element-248">
                  {currentName} de {currentCity}
                </p>
                <p className="text-white/60 text-xs leading-tight mt-0.5" data-id="element-249">
                  acaba de comprar{' '}
                  <span className="text-white/80 font-medium" data-id="element-250">
                    {productName}
                  </span>
                </p>
                <p className="text-amber-gold font-bold text-sm mt-0.5" data-id="element-251">
                  $6.39
                </p>
              </div>
              <span className="text-white/30 text-xs flex-shrink-0" data-id="element-252">ahora</span>
            </div>
          </motion.div>}
      </AnimatePresence>
    </div>;
}